"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _icon = _interopRequireDefault(require("../icon"));
var _CustomMenuList2 = _interopRequireDefault(require("./CustomMenuList.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CustomMenuList = /*#__PURE__*/function (_React$Component) {
  function CustomMenuList(props) {
    var _this;
    _classCallCheck(this, CustomMenuList);
    _this = _callSuper(this, CustomMenuList, [props]);
    _defineProperty(_this, "handleClickOutside", function () {
      _this.setState({
        isExpanded: false
      });
    });
    _defineProperty(_this, "toggleMenuVisibility", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
    });
    _this.state = {
      isExpanded: false
    };
    return _this;
  }
  _inherits(CustomMenuList, _React$Component);
  return _createClass(CustomMenuList, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        menuConfig = _this$props.menuConfig,
        className = _this$props.className,
        ariaLabel = _this$props.ariaLabel;
      var isExpanded = this.state.isExpanded;
      return /*#__PURE__*/_react["default"].createElement(_CustomMenuList2["default"], {
        className: className
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "content-toggler ".concat(isExpanded ? 'active' : ''),
        onClick: this.toggleMenuVisibility,
        onKeyDown: this.toggleMenuVisibility,
        role: "button",
        "aria-label": ariaLabel || 'Expand menu',
        tabIndex: "0"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        className: "icon-ion-android-more-vertical"
      })), isExpanded && /*#__PURE__*/_react["default"].createElement("ul", {
        className: "menu-list"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        id: "report-menu-close",
        icon: "ion-close-circled",
        size: 18,
        className: "report-menu-close-icon",
        "aria-label": "Close pop-up",
        onClick: this.handleClickOutside
      }), R.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "menu-item ".concat(item.disabled ? 'disabled' : ''),
          onClick: _this2.handleClickOutside,
          onKeyDown: _this2.handleClickOutside,
          role: "presentation",
          key: item.key || item.icon
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          className: item.icon,
          size: item.iconSize
        }), item.menuItemRenderer());
      }, menuConfig)));
    }
  }]);
}(_react["default"].Component);
CustomMenuList.defaultProps = {
  className: '',
  ariaLabel: ''
};
CustomMenuList.propTypes = {
  menuConfig: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].arrayOf(_propTypes["default"].shape({}))]).isRequired,
  className: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)((0, _reactClickOutside["default"])(CustomMenuList));